import { render, staticRenderFns } from "./analisisSeguimientoVentanilla.vue?vue&type=template&id=27d99cb3&"
import script from "./analisisSeguimientoVentanilla.vue?vue&type=script&lang=js&"
export * from "./analisisSeguimientoVentanilla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports